/**
 * buildSupportMailto — constructs a mailto: URL prefilled with session
 * context so support@juuniai.com receives triage-ready issue reports.
 *
 * Only includes non-sensitive context: org_id (already in JWT), role,
 * current URL path, user agent. No tokens, no PII beyond what's already
 * visible in the app.
 */

export function buildSupportMailto({ orgId, role, path, subject, sentryEventId, intro } = {}) {
  const to = 'support@juuniai.com';
  const subj = subject || 'Juuni support request';

  // Gather session context — optional fields stay out if missing
  const ctx = [];
  if (role) ctx.push(`Role: ${role}`);
  if (orgId) ctx.push(`Org ID: ${orgId}`);
  if (path) ctx.push(`Page: ${path}`);
  if (typeof window !== 'undefined') {
    if (window.location?.href) ctx.push(`URL: ${window.location.href}`);
    if (window.navigator?.userAgent) ctx.push(`Browser: ${window.navigator.userAgent}`);
  }
  if (sentryEventId) ctx.push(`Sentry Event ID: ${sentryEventId}`);
  ctx.push(`Time: ${new Date().toISOString()}`);

  const bodyIntro = intro || '<describe your issue here>';

  const body = [
    'Hi Juuni team,',
    '',
    bodyIntro,
    '',
    '---',
    'Session context (auto-populated — leave in place to help us triage):',
    ...ctx,
  ].join('\n');

  return `mailto:${to}?subject=${encodeURIComponent(subj)}&body=${encodeURIComponent(body)}`;
}
